import "./App.css";
import LandingPage from "./screens/LandingPage";

function App() {
  return <LandingPage />;
}

export default App;
